/**
 * @generated SignedSource<<c6eec8a77c95cc70e7353e2e55232745>>
 * @relayHash 4117f103096127078fb504136552577e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7db3df11357d17fad1376b0e799c3b875cd283fd13b1d944b50d30c9ce7397f0

import type { ConcreteRequest } from 'relay-runtime';
export type BylineSmartLinksQuery$variables = {
  contentId: string;
  first: number;
  smartLinksFromDraft: boolean;
};
export type BylineSmartLinksQuery$data = {
  readonly confluence_contentSmartLinksForDraft?: {
    readonly nodes: ReadonlyArray<{
      readonly product: string | null;
      readonly url: string;
    } | null> | null;
  } | null;
  readonly contentSmartLinks?: {
    readonly nodes: ReadonlyArray<{
      readonly product: string | null;
      readonly url: string;
    } | null> | null;
  } | null;
};
export type BylineSmartLinksQuery = {
  response: BylineSmartLinksQuery$data;
  variables: BylineSmartLinksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "smartLinksFromDraft"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  },
  {
    "kind": "Literal",
    "name": "includeHyperlinks",
    "value": true
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "url"
},
v3 = {
  "kind": "ScalarField",
  "name": "product"
},
v4 = [
  {
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v2/*: any*/),
      (v3/*: any*/)
    ]
  }
],
v5 = [
  {
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      (v2/*: any*/),
      (v3/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "BylineSmartLinksQuery",
    "selections": [
      {
        "condition": "smartLinksFromDraft",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "PaginatedSmartLinkList",
            "kind": "LinkedField",
            "name": "contentSmartLinks",
            "plural": false,
            "selections": (v4/*: any*/)
          }
        ]
      },
      {
        "condition": "smartLinksFromDraft",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "PaginatedSmartLinkList",
            "kind": "LinkedField",
            "name": "confluence_contentSmartLinksForDraft",
            "plural": false,
            "selections": (v4/*: any*/)
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BylineSmartLinksQuery",
    "selections": [
      {
        "condition": "smartLinksFromDraft",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "PaginatedSmartLinkList",
            "kind": "LinkedField",
            "name": "contentSmartLinks",
            "plural": false,
            "selections": (v5/*: any*/)
          }
        ]
      },
      {
        "condition": "smartLinksFromDraft",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "PaginatedSmartLinkList",
            "kind": "LinkedField",
            "name": "confluence_contentSmartLinksForDraft",
            "plural": false,
            "selections": (v5/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "4117f103096127078fb504136552577e",
    "id": "7db3df11357d17fad1376b0e799c3b875cd283fd13b1d944b50d30c9ce7397f0",
    "metadata": {},
    "name": "BylineSmartLinksQuery",
    "operationKind": "query",
    "text": "query BylineSmartLinksQuery($contentId:ID!,$first:Int!,$smartLinksFromDraft:Boolean!){contentSmartLinks(id:$contentId,first:$first,includeHyperlinks:true)@skip(if:$smartLinksFromDraft){nodes{__typename,url,product}},confluence_contentSmartLinksForDraft(id:$contentId,first:$first,includeHyperlinks:true)@include(if:$smartLinksFromDraft){nodes{__typename,url,product}}}"
  }
};
})();

(node as any).hash = "4aca631788e436f435de99bf5dd4f391";

export default node;
